import type {
  IAccountSummary,
  IClstAccount,
} from "@pulse-ui/codegen-v2/generated_ts/clst_account";

export interface SelectOption {
  value: string;
  label: string;
}

/** Case-sensitive substring match on the account id or display name; empty keeps all. */
export function filterAccountSummaries(
  rows: IAccountSummary[],
  name?: string,
): IAccountSummary[] {
  if (!name) return rows;
  return rows.filter((r) => r.account_id.includes(name) || r.display_name.includes(name));
}

/** Account picker options keyed by account id, sorted by trimmed display name. */
export function accountSummariesToOptions(
  rows: IAccountSummary[],
  name?: string,
): SelectOption[] {
  return filterAccountSummaries(rows, name)
    .map((r) => ({ value: r.account_id, label: r.display_name.trim() }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

/** The legacy clst account shape, with both `id` and `name` set to the account id. */
export function accountSummariesToClstAccounts(rows: IAccountSummary[]): IClstAccount[] {
  return rows.map((r) => ({ id: r.account_id, name: r.account_id, display_name: r.display_name }));
}
